<template>
  <div v-if="isAudit" style="overflow: auto">
    <a-card hoverable :bordered="false">
      <a-row type="flex">
        <a-col class="mr_20">
          <span>上传日期：</span>
          <a-date-picker
            v-model="start"
            @change="onStart"
            format="YYYY-MM-DD"
            placeholder="请选择开始日期"
            style="width: 150px"
          />
          -
          <a-date-picker
            v-model="end"
            @change="onEnd"
            placeholder="请选择结束日期"
            style="width: 150px"
          />
        </a-col>
        <a-col class="mr_20">
          <span>审核日期：</span>
          <a-date-picker
            v-model="starts"
            @change="onStarts"
            format="YYYY-MM-DD"
            placeholder="请选择开始日期"
            style="width: 150px"
          />
          -
          <a-date-picker
            v-model="ends"
            @change="onEnds"
            placeholder="请选择结束日期"
            style="width: 150px"
          />
        </a-col>
        <!-- <a-col>
          <span>审核状态：</span>
          <a-radio-group
            style="line-height: 32px"
            class="mr_20"
            :options="plainOptions"
            :default-value="'待处理'"
            @change="onChange1"
          />
        </a-col> -->
        <a-col class="flex">
          <a-input
            ref="userNameInput"
            v-model="works_name"
            placeholder="输入产品名称搜索"
          >
            <a-icon slot="prefix" type="search" />
          </a-input>
          <a-button class="ml_20" type="primary" @click="getData"> 搜索 </a-button>
          <a-button class="ml_20" @click="resetBtn"> 重置 </a-button>
          <!-- <a-button class="ml_20" type="primary" @click="goAudits">
            批量审核
          </a-button> -->
        </a-col>
      </a-row>
    </a-card>
    <a-card
      style="margin-top: 16px; overflow: auto"
      hoverable
      :bordered="false"
    >
    <a-tabs :default-active-key="status" @change="tabChange">
        <a-tab-pane key="0" tab="全部"></a-tab-pane>
        <!-- <a-tab-pane
          key="1"
          tab="报审中"
        ></a-tab-pane> -->
        <a-tab-pane
          key="2"
          tab="报审通过"
          force-render
        ></a-tab-pane>
        <a-tab-pane
          key="3"
          tab="报审驳回"
          force-render
        ></a-tab-pane>
        <a-tab-pane
          key="4"
          tab="建议修改"
          force-render
        ></a-tab-pane>
        <a-tab-pane
          key="5"
          tab="放弃审核"
          force-render
        ></a-tab-pane>
      </a-tabs>
      <a-table
        :columns="columns"
        :data-source="data"
        :pagination="pagination"
        
        :scroll="{ y: tableH - 150 }"
      >
      <!-- :row-selection="{ onSelect: selectTable, onSelectAll: selectAll }" -->
      <span slot="status" slot-scope="text, record">
          <a v-if="record.status == 2" style="color:#F59A23" >待处理</a>
          <a v-else style="color:green" >已处理</a>
        </span>
        <span slot="handle" slot-scope="text, record">
          <a v-if="record.status == 2" @click="goAudit(record)">审核</a>
          <a v-else @click="goAudit(record, 'examine')">查看</a>
        </span>
        <!-- <span v-if="record.is_second&&record.ai_status_desc_second" slot="ai_status_desc" style="color:red" slot-scope="text, record" v-html="record.ai_status_desc_second">
        </span>
        <span v-else-if="!record.is_second&&record.ai_status_desc" slot="ai_status_desc" style="color:red" slot-scope="text, record" v-html="record.ai_status_desc">
        </span>
        <span v-else slot="ai_status_desc" style="color:green" slot-scope="text, record" >
          正常
        </span> -->
        <!-- <span v-if="!record.is_second&&record.man_status_desc" slot="man_status_desc" style="color:red" slot-scope="text, record" v-html="record.man_status_desc">
        </span>
        <span v-else-if="record.is_second&&record.man_status_desc_second" slot="man_status_desc" style="color:red" slot-scope="text, record" v-html="record.man_status_desc_second">
        </span>
        <span v-else slot="man_status_desc" style="color:green" slot-scope="text, record" >
          正常
        </span> -->
        <!-- <span v-if="record.is_second&&!record.man_status_desc&&!record.man_status_desc_second" slot="man_status_desc" style="color:green" slot-scope="text, record" >
          正常
        </span> -->
         <span v-if="!record.is_second&&record.man_status_desc" slot="man_status_desc" style="color:red" slot-scope="text, record" v-html="record.man_status_desc">
        </span>
        <span v-else-if="record.is_second&&record.man_status_desc_second" slot="man_status_desc" style="color:red" slot-scope="text, record" v-html="record.man_status_desc_second">
        </span>
        <!--<span v-else-if="record.is_finish&&record.man_status_desc.length" slot="man_status_desc" style="color:red" slot-scope="text, record" v-html="record.man_status_desc">
        </span>
        <span v-else-if="record.is_finish&&record.man_status_desc.length" slot="man_status_desc" style="color:red" slot-scope="text, record" v-html="record.man_status_desc">
        </span> -->
        <span slot="xhfs" slot-scope="text, record">
          <!-- <a v-if="record.status == 2" @click="goAudit(record)">审核</a> -->
          <!-- <a v-else @click="goAudit(record, 'examine')">查看</a> -->
          <span v-if="record.status == 4&&record.is_edit == 1" style="color:#f0ad4e">建议修改</span>
          <span v-else-if="record.status == 3&&record.is_edit == 2" style="color:green">通过</span>
          <span v-else-if="record.status == 4&&record.is_edit == 2" style="color:red">已驳回</span>
          <span v-else-if="record.status == 5" style="color:red">放弃审核</span>
        </span>
      </a-table>
    </a-card>

    <a-modal :visible="logModal" :footer="null" @cancel="logModal = false">
      <a-timeline mode="alternate" style="padding-top: 30px">
        <a-timeline-item>Create a services site 2015-09-01</a-timeline-item>
        <a-timeline-item color="green">
          Solve initial network problems 2015-09-01
        </a-timeline-item>
        <a-timeline-item color="red">
          机构未通过 2021-08-19 17:49:16
        </a-timeline-item>
        <a-timeline-item color="green">报审通过 2015-09-01</a-timeline-item>
        <a-timeline-item> 开始审核 2021-08-19 17:49:16 </a-timeline-item>
      </a-timeline>
    </a-modal>
  </div>
  <AuditModule @setIsAudit="getIsAudit" :auditData="auditData" v-else/>
</template>

<script>
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
import {result_list} from "@/api/association"
import AuditModule from "@/components/audit"//注册审核组件
const plainOptions = ["待处理", "已处理"];
const options = [
  { label: "待处理", value: "待处理" },
  { label: "已处理", value: "已处理" },
];

const columns = [
  {
    title: "序号",
    dataIndex: "id",
    align: "center",
  },
  {
    title: "产品名称",
    dataIndex: "works_name",
    align: "center",
  },
  {
    title: "审核人员",
    dataIndex: "name",
    align: "center",
  },
  {
    title: "分配时间",
    dataIndex: "created_at",
    align: "center",
    sorter: (a, b) => {return a.upload_time > b.upload_time ? 1 : -1},
  },
  {
    title: "产品优先级",
    dataIndex: "priority",
    align: "center",
    scopedSlots: { customRender: "priority" },
  },
  /* {
    title: "任务状态",
    dataIndex: "status",
    align: "center",
    scopedSlots: { customRender: "status" },
  }, */
  {
    title: "机构审核",
    dataIndex: "man_status_desc",
    align: "center",
    scopedSlots: { customRender: "man_status_desc" },
  },
  {
    title: "协会复审",
    dataIndex: "xhfs",
    align: "center",
    scopedSlots: { customRender: "xhfs" },
  },
  {
    title: "操作",
    key: "handle",
    align: "center",
    scopedSlots: { customRender: "handle" },
  },
];

const data = [];

function datas() {
  for (let i = 0; i < 100; i++) {
    let obj = {
      id: i + 1,
      name: "作品名称" + i,
      user: "审核人员" + i,
      date: "2021-09-24",
      status: "1",
      result: "这是一条很长很长很长很长很长很长很长很长很长的审核结果",
      audit: "",
    };
    data.push(obj);
  }
}
// datas();

export default {
  components:{AuditModule},
  data() {
    return {
      plainOptions,
      options,
      value1: "Apple",
      locale,
      moment,
      ids: [],
      currentPageData: [],
      tableH: "", //表格容器高度
      columns,    //表格抬头
      data,       //表格数据
      works_name: "", //作品名称
      pagination: {
        //表格分页
        current: 1,
        total: 0,
        pageSize: 20, //每页中显示10条数据
        showSizeChanger: true,
        showLessItems: true,
        // hideOnSinglePage: true,
        pageSizeOptions: ["10", "20", "50", "100"], //每页中显示的数据
        showTotal: (total) => `共有 ${total} 条数据`, //分页中显示总的数据
        onChange: (page, pageSize) => {
          (this.pagination.current = page),
            (this.pagination.pageSize = pageSize);
          this.getData(this.status);
        },
        onShowSizeChange: (page, pageSize) => {
          (this.pagination.current = page),
            (this.pagination.pageSize = pageSize);
          this.getData(this.status);
        },
      },
      logModal: false,
      start: "",
      end: "",
      starts: "",
      ends: "",
      lens:"",
      status:"",

      /* 审核子组件 */
      isAudit:true,//审核组件显示
      auditData:"",//审核组件需要的data数据
    };
  },
  created() {
    this.getData()
  },
  mounted() {
    //表格高度自适应
    this.$nextTick(function () {
      this.tableH = document.body.clientHeight - 200; //259
      // tableDom.style.height= this.tableH+"px" //表格滚动条预留
    });
    //窗口改变自适应
    window.onresize = () => {
      return (() => {
        this.tableH = window.innerHeight - 200; //259
        // tableDom.style.height= this.tableH+"px" //表格滚动条预留
      })();
    };
  },
  methods: {
    //审核组件返回的按钮
    getIsAudit(val,reload,paramsVal){
      this.isAudit = val
      if(paramsVal){
        this.status = paramsVal.status
      }
      if(reload){
        this.getData();
      }
    },
    //重置按钮
    resetBtn(){
      this.start = ""
      this.end = ""
      this.starts = ""
      this.ends = ""
      this.works_name = ""
    },
    //获取任务列表
    getData() {
      this.$store.commit("spinning", true);
      result_list({
        // id:this.$store.state.user.id,
        page_size: this.pagination.pageSize,
        page_no: this.pagination.current,
        works_name: this.works_name,
        status:this.status,
        start:this.start,
        end:this.end,
        starts:this.starts,
        ends:this.ends
      }).then((res) => {
        console.log("任务列表",res.data)
        if (res) {
          this.data = res.data.data
          this.lens = {
            total:res.data.all_count,
            finish_count:res.data.finish_count,
            not_finish_count:res.data.wait_count 
          }
          this.pagination.total = res.total
          this.$store.commit("spinning", false);
        }
      });
    },

    //切换tab的动作
    tabChange(id){
      this.status = id == "0" ? "" : id
      this.getData()
    },
    //时间选择器
    onStart(data, dateString) {
      console.log(dateString);
      this.start = dateString;
    },
    onEnd(data, dateString) {
      console.log(dateString);
      let y = parseInt(dateString.split("-")[0]);
      let yy = parseInt(this.start.split("-")[0]);
      let m = parseInt(dateString.split("-")[1]);
      let mm = parseInt(this.start.split("-")[1]);
      let d = parseInt(dateString.split("-")[2]);
      let dd = parseInt(this.start.split("-")[2]);
      if (y < yy) {
        this.$message.error({
          content: "结束日期不能小于开始日期，请重新选择",
          duration: 2,
        });
        this.end = "";
      } else if (m < mm) {
        this.$message.error({
          content: "结束日期不能小于开始日期，请重新选择",
          duration: 2,
        });
        this.end = "";
      } else if (d < dd) {
        this.$message.error({
          content: "结束日期不能小于开始日期，请重新选择",
          duration: 2,
        });
        this.end = "";
      } else {
        this.end = dateString;
      }
    },
    onStarts(data, dateString) {
      console.log(dateString);
      this.starts = dateString;
    },
    onEnds(data, dateString) {
      console.log(dateString);
      let y = parseInt(dateString.split("-")[0]);
      let yy = parseInt(this.starts.split("-")[0]);
      let m = parseInt(dateString.split("-")[1]);
      let mm = parseInt(this.starts.split("-")[1]);
      let d = parseInt(dateString.split("-")[2]);
      let dd = parseInt(this.starts.split("-")[2]);
      if (y < yy) {
        this.$message.error({
          content: "结束日期不能小于开始日期，请重新选择",
          duration: 2,
        });
        this.ends = "";
      } else if (m < mm) {
        this.$message.error({
          content: "结束日期不能小于开始日期，请重新选择",
          duration: 2,
        });
        this.ends = "";
      } else if (d < dd) {
        this.$message.error({
          content: "结束日期不能小于开始日期，请重新选择",
          duration: 2,
        });
        this.ends = "";
      } else {
        this.ends = dateString;
      }
    },
    //跳转剧本详情
    goAudit(record, examine) {
      console.log("选择的id", record,examine);
      this.isAudit = false
      this.auditData = { id: record.id,type:examine,task:"task",status:this.status}
      // this.$router.push({ name: "components_audit", params: { id: record.id,type:examine,task:"task"} });
    },
  },
};
</script>

<style lang="less" scoped>
.ant-row,
.btns {
  height: 40px;
  line-height: 40px;
  .btns {
    display: flex;
    justify-content: space-between;
    .ant-btn {
      margin: auto 0;
    }
  }
}
</style>